import { Userpilot } from 'userpilot';
import { TelemetryPluginWithConfig } from '../types';

type UserPilotPluginConfig = {
  appToken: string;
};

const name = 'user-pilot';

declare module './Plugins' {
  interface Plugins {
    [name]: undefined;
  }
}

export const UserPilotPlugin: TelemetryPluginWithConfig<UserPilotPluginConfig> = ({ appToken }) => {
  return {
    name,

    init({ user }) {
      Userpilot.initialize(appToken);

      try {
        if (user) {
          Userpilot.identify(user.id, {
            name: `${user.details?.firstName} ${user.details?.lastName}`,
            email: user.email,
            organisationType: user.organisation.orgType,
            jobTitle: user.details?.jobTitle,
            userGroupId: user.userGroup.id,
            userGroupAlias: user.userGroup.alias,
            sellerFeaturesEnabled: user.organisation.sellerFeaturesEnabled,
            organisationAdmin: user.organisationAdmin,
            company: {
              id: user.organisation.id,
              name: user.organisation.details.name,
            },
          });
        } else {
          Userpilot.anonymous();
        }
      } catch {
        console.error('Unable to send user to Userpilot');
      }
    },

    onRouteChange() {
      Userpilot.reload();
    },
  };
};
